import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.3.1_db0@0.3.2_eslint@8.57.0_ioredis@5._c0a1e660fe67abdfc47f541cb7aa99ba/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}